import React from 'react';

const Color = () => {

    return (
        <div>
        {/* // <!-- ========== Start Color Switcher ========== --> */}
            <div className="switch-button"><i className="fa fa-cog fa-spin"></i></div>
            <div className="switched-styles">
                <h4>Color Switcher</h4>
                <ul className="list-unstyled">
                    <li data-color="yellow"></li>
                    <li data-color="aqua"></li>
                    <li data-color="gold"></li>
                    <li data-color="red"></li>
                    <li data-color="blue"></li>
                    <li data-color="green"></li>
                    <li data-color="purble"></li>
                    <li data-color="rose"></li>
                </ul>
                <div className="hide-button">&times;</div>
            </div>
            {/* // <!-- ========== End Color Switcher ========== -->  */}
        </div>

    );

}

export { Color };
